<template>
    <div class="mx-3">
        <payer-contract-upload :client-id="client.id"></payer-contract-upload>
        <payer-contract-association-modal></payer-contract-association-modal>
        <delete-confirmation name="payer contract" @confirm="deleteContract"></delete-confirmation>

        <div v-if="showName" class="font-weight-bold">{{ client.name }}</div>
        <div class="d-flex justify-content-between align-items-end border-bottom">
            <div>
                <h2 class="d-inline-block">Payer Contracts</h2>
            </div>
            <div class="btn-toolbar mb-2" role="toolbar">
                <div class="btn-group">
                    <button class="btn btn-primary m-0" @click="upload()" title="Upload Payer Contract"><i class="fas fa-file-upload fa-lg"></i></button>
                    <a :href="`/provider/clients/${client.id}/payers`" class="btn btn-primary" title="Back to Payer List">
                        <i class="fas fa-arrow-alt-circle-left fa-lg"></i>
                    </a>
                </div>
            </div>
        </div>
        <div v-if="contracts.length" class="table-responsive">
            <table class="table table-sm border-none-top">
                <thead>
                    <tr>
                        <th>Description</th>
                        <th class="text-right">Rate</th>
                        <th>Activated</th>
                        <th>Terminated</th>
                        <th class="text-right">Payers</th>
                        <th class="text-right">Claims</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="contract in contracts" :key="'payer-contract-' + contract.id">
                        <td>
                            <input v-if="contract.editDescription" type="text" class="form-control form-control-sm" v-model="contract.description" @blur="changeDescription(contract)" @keyup.enter="changeDescription(contract)" v-focus>
                            <span v-else @click="$set(contract, 'editDescription', true)" :title="contract.description">                             
                                {{ contract.description }}
                                <a href="javascript:void(0)"><i class="fas fa-pencil-alt fa-xs"></i></a>
                            </span>
                        </td>                            
                        <td class="text-right">{{ contract.rate }}%</td>
                        <td>{{ contract.activated_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                        <td>{{ contract.terminated_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                        <td class="text-right">{{ contract.client_payers_count }}</td>
                        <td class="text-right">{{ contract.service_forms_count }}</td>
                        <td class="text-right">                              
                            <button class="btn btn-sm btn-primary" :disabled="contract.active" @click="activate(contract.id)">Activate</button>
                            <button class="btn btn-sm btn-danger" :disabled="!contract.active" @click="terminate(contract.id)">Terminate</button>

                            <button class="btn btn-sm btn-primary ml-2" title="Associate Payers" @click="associate(contract)"><i class="fas fa-link fa-lg"></i></button>                            
                            <a :href="`/clients/${client.id}/payercontracts/${contract.id}`" class="btn btn-sm btn-primary" title="Download Payer Contract" target="_blank">
                                <i class="fas fa-file-download fa-lg"></i>
                            </a>
                            <button class="btn btn-sm btn-primary" :disabled="contract.service_forms_count > 0" @click="confirmDelete(contract)" title="Delete Payer Contract"><i class="fas fa-trash-alt fa-lg"></i></button>                                  
                        </td>                                                                
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="pt-3">
            <h3 class="text-muted">No payer contracts have been uploaded.</h3>
        </div>
    </div>   
</template>

<script>
import PayerContractUpload from './PayerContractUploadComponent.vue';
import PayerContractAssociationModal from './PayerContractAssociationComponent.vue';
export default {
    components: {
        PayerContractUpload,
        PayerContractAssociationModal
    },
    props: {
        client: Object,
        showName: Boolean
    },
    data() {
        return {
            contracts: [],
        }
    },
    methods: {
        refresh: function () {

            axios.get('/ajax/provider/clients/' + this.client.id + '/payercontracts')
                .then(response => {
                    this.contracts = response.data.contracts;
                })
                .catch(error => {
                    toastr['error'](error.response.data, 'ERROR', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                });
        },    
        upload: function () {
        
            eventHub.$emit('show-payer-contract-upload', this.refresh);
        },
        activate: function (contractId) {
            axios.patch('/ajax/provider/clients/' + this.client.id + '/payercontracts/' + contractId + '/activate')
                .then(response => {

                    this.refresh();
                })
                .catch(error => {

                    toastr['error'](error.response.data.message, 'ERROR', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                });
        },
        terminate: function (contractId) {

            axios.patch('/ajax/provider/clients/' + this.client.id + '/payercontracts/' + contractId + '/terminate')
                .then(response => {

                    this.refresh();
                })
                .catch(error => {

                    toastr['error'](error.response.data.message, 'ERROR', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                });
        },
        confirmDelete: function (contract) {

            if (contract.client_payers_count > 0) {
                eventHub.$emit('show-delete-payer-contract-confirmation', contract.id);
            }
            else {
                this.deleteContract(contract.id);
            }
        },
        deleteContract: function (contractId) {

            axios.delete('/ajax/provider/clients/' + this.client.id + '/payercontracts/' + contractId)
                .then(response => {

                    this.refresh();
                })
                .catch(error => {

                    toastr['error'](error.response.data.message, 'ERROR', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                });
        },
        changeDescription: function (contract) {

            contract.editDescription = false;

            // update the model
            this.$emit('update');

            // send the change to the server
            axios.patch(`/ajax/provider/clients/${this.client.id}/payercontracts/${contract.id}/description`, {
                'description': contract.description,
            });            
        },
        associate: function (contract) {

            eventHub.$emit('show-associate-payer-contract', contract);
        } 
    },
    created() {
        
        // listen for payer contract events
        window.Echo.private('payer-contract-event.' + this.client.id).listen('PayerContractEvent', (e) => {
            this.refresh();
        });        

        this.refresh();
    },
    directives: {
        focus: {
            inserted: function (el) {
                el.focus();
            }
        }
    }        
}
</script>

<style scoped>
    .font-small {
        font-size: .95em;
    }
</style>